import { Create, CreateProps, Datagrid, DateField, DateInput, Edit, EditProps, FileFieldProps, FileInput, FormDataConsumer, FunctionField, ImageField, ImageInput, List, ListProps, NumberField, ReferenceField, ReferenceInput, SelectInput, SimpleForm, TextField, TextInput, useRecordContext } from "react-admin";
import { useListStyles } from "../AppTheme";
import { MEDIA_URL } from "../constants";
import { ResourceActions } from "../helper";

const VideoField = (filefield: FileFieldProps) => {
  console.log(filefield.record);
  if (filefield.record?.undefined) {
    return (
      <video src={filefield.record?.undefined} controls />
    )
  }
  return (
    <video src={filefield.record?.rawFile.src} controls />
  )
}

const ConditionalMediaInput = (formData: any) => {
  // console.log(formData);
  const classes = useListStyles();
  switch (formData.type) {
    case 0:
      return (
        <div>
          <ImageInput  source="InputMedia" labelSingle={formData.src && !!!formData.InputMedia ? "Replace image" : "Drag an image into here"} accept="image/*" multiple={false}  >
            <ImageField source="src" title="title" />
          </ImageInput>
          {formData.src && !!!formData.InputMedia && <img className={classes.mediaImage} src={`${MEDIA_URL}/${formData.src}`} />}
        </div>
      )
    case 1:
      return (
        <div>
          <FileInput source="InputMedia" labelSingle={formData.src && !!!formData.InputMedia ? "Replace video" : "Drag a video into here"} accept="video/*" multiple={false}>
            <VideoField />
          </FileInput>
          {formData.src && !!!formData.InputMedia && <video src={`${MEDIA_URL}/${formData.src}`} controls />}
        </div>
      )
  }
}

export const ConditionalMediaRender = (formdata: any) => {
  const classes = useListStyles();
  if (!formdata.Media) return (
    <div></div>
  )

  switch (formdata.Media.type) {
    case 0:
      return (
        <div>
          <img className={classes.editImage} src={`${MEDIA_URL}/${formdata.Media.src}`} />

        </div>
      )
    case 1:
      return (
        <div>
          <video src={`${MEDIA_URL}/${formdata.Media.src}`} controls />

        </div>
      )
    default:
      return (
        <div>Unknown Type</div>
      )
  }

}

export const ArtefactMediaEdit = (props: EditProps) => {
  return (
    <Edit actions={<ResourceActions />} {...props} undoable={false}>
      <SimpleForm>
        <TextInput disabled source="id" />
        <TextInput disabled source="src" />
        <TextInput source="title" />
        <SelectInput source="type" choices={[
          { id: 0, name: 'image' },
          { id: 1, name: 'video' },
        ]} />
        <ReferenceInput source="artefactId" reference="artefacts" >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <DateInput disabled source="createdAt" />
        <DateInput disabled source="updatedAt" />
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            ConditionalMediaInput(formData)
          )}
        </FormDataConsumer>

      </SimpleForm>
    </Edit>
  )
};

export const ArtefactMediaCreate = (props: CreateProps) => (
  <Create actions={<ResourceActions />} {...props}>
    <SimpleForm>
      <TextInput disabled source="src" />
      <TextInput source="title" />
      <SelectInput source="type" choices={[
        { id: 0, name: 'image' },
        { id: 1, name: 'video' },
      ]} />

      <FormDataConsumer>
        {({ formData, ...rest }) => (
          ConditionalMediaInput(formData)
        )}
      </FormDataConsumer>

      <ReferenceInput source="artefactId" reference="artefacts">
        <SelectInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const ArtefactMediaList = (props: ListProps) => (
  <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="id" label="ID"/>
        <TextField source="src" label="Source"/>
        <TextField source="title" />
        <FunctionField label="Type" render={(record: any) => record.type == 0 ? "Image" : "Video" }/>
        <DateField source="createdAt" label="Created At"/>
        <DateField source="updatedAt" label="Updated At"/>
        <ReferenceField source="artefactId" reference="artefacts"><TextField source="name" /></ReferenceField>
      </Datagrid>
  </List>
);